import React, { Fragment } from "react";
import { useTranslation } from "@1f/react-sdk";
import VaporTag from "@vapor/react-custom/VaporTag";
import Stack from "@vapor/react-material/Stack";
import Card from "@vapor/react-material/Card";
import CardContent from "@vapor/react-material/CardContent";
import Box from "@vapor/react-material/Box";
import Button from "@vapor/react-material/Button";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import { Tooltip as TooltipMaterial } from "@vapor/react-material";
import { VersionAlert } from "../../../components/VersionAlert";
import {
  pathAziendaAdd,
  pathFascicoloAdd,
  pathAutoValutazioneAdd,
} from "../../../businessLogic/constants/path";
import { chipRed } from "../../../businessLogic/styles";

export const DashboardHeader = ({
  user,
  lastActivity,
  hasMalformedPiva,
  duplicatesAnags,
  duplicatesManipulation,
  blockingDuplicates,
  userRespAntiricName,
  respAntiricPermsError,
  livelloS,
  livelloC,
  message,
  onLastActivityClick,
  onGoToErrAnag,
  onReopenDuplicatesModal,
}) => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" spacing={2}>
      <Card sx={{ width: "100%" }}>
        <CardContent sx={{ p: 0, pb: "0 !important" }}>
          <Stack
            direction="row"
            sx={{
              flexWrap: "wrap",
              alignItems: "stretch",
            }}
          >
            <Stack
              direction="column"
              sx={{
                p: { xs: 2, md: 4 },
                flex: "1 1 560px",
                minWidth: 0,
              }}
              spacing={2}
            >
              <ExtendedTypography variant="titleMedium" color="primary.main">
                {t("dashboard.welcome")} {user.completeName}
              </ExtendedTypography>
              {lastActivity.path !== "" ? (
                <Fragment>
                  <ExtendedTypography variant="p" color="text.secondary">
                    {t("dashboard.resume")} {lastActivity.area}
                    {lastActivity.path === pathAziendaAdd ? " " : null}
                    {lastActivity.path === pathFascicoloAdd ? " di " : null}
                    {lastActivity.path === pathAutoValutazioneAdd ? " del " : null}
                    {lastActivity.entityName}?
                  </ExtendedTypography>
                </Fragment>
              ) : null}
              <Stack direction="row" spacing={2} sx={{ flexWrap: "wrap", rowGap: 1 }}>
                {lastActivity.path !== "" && (
                  <Button
                    variant="contained"
                    size="small"
                    sx={{ width: { xs: "100%", sm: "200px" } }}
                    onClick={onLastActivityClick}
                  >
                    {t("dashboard.resumeButton")}
                  </Button>
                )}
                {hasMalformedPiva && (
                  <TooltipMaterial
                    title="Premendo su questo bottone la procedura ti mostrerà le anagrafiche che hanno una P.Iva non valida e potrai modificarla tramite l'apposito form"
                    arrow
                    placement="right"
                  >
                    <Button
                      variant="contained"
                      size="small"
                      color="error"
                      sx={{ width: { xs: "100%", sm: "200px" } }}
                      onClick={onGoToErrAnag}
                    >
                      Correzione P. Iva errate
                    </Button>
                  </TooltipMaterial>
                )}
                {!blockingDuplicates &&
                  (duplicatesAnags.length > 0 ||
                    (duplicatesManipulation &&
                      duplicatesManipulation.duplicated > 0)) && (
                  <TooltipMaterial
                    title="Sono state rilevate anagrafiche duplicate. Clicca per selezionare quali mantenere."
                    arrow
                    placement="right"
                  >
                    <Button
                      variant="contained"
                      size="small"
                      color="error"
                      sx={{ width: { xs: "100%", sm: "250px" } }}
                      onClick={onReopenDuplicatesModal}
                    >
                      ⚠️ Anagrafiche Duplicate (
                      {duplicatesManipulation.duplicated})
                    </Button>
                  </TooltipMaterial>
                )}
              </Stack>
            </Stack>

            <Stack
              direction="column"
              sx={{
                p: { xs: 2, md: 4 },
                flex: "0 1 420px",
                minWidth: { xs: "100%", lg: "360px" },
              }}
              spacing={1}
            >
              <Box sx={{ mb: 1 }}>
                <VersionAlert messageFromParent={message} />
              </Box>
              <ExtendedTypography variant="titleSmall" color="primary.main">
                {t("dashboard.amlresp")}
              </ExtendedTypography>
              {respAntiricPermsError ? (
                <VaporTag
                  variant="standard"
                  label="Non hai i permessi per leggere i ruoli dell'azienda"
                  sx={chipRed}
                />
              ) : userRespAntiricName !== "" ? (
                <VaporTag
                  variant="ghost"
                  type="blueSapphire"
                  label={userRespAntiricName}
                />
              ) : (
                <VaporTag
                  variant="ghost"
                  type="blueSapphire"
                  label={t("dashboard.label1")}
                />
              )}
              <ExtendedTypography variant="titleSmall" color="primary.main">
                {t("dashboard.lvlrisk")}
              </ExtendedTypography>
              {livelloS === "" ? (
                <Fragment>
                  <VaporTag
                    variant="ghost"
                    type="blueSapphire"
                    label={t("dashboard.label2")}
                  />
                </Fragment>
              ) : null}
              {livelloS !== "" ? (
                <Fragment>
                  <VaporTag variant="standard" label={livelloS} sx={livelloC} />
                </Fragment>
              ) : null}
            </Stack>
          </Stack>
        </CardContent>
      </Card>
    </Stack>
  );
};
